export const releaseModalScrollLock = () => {
  if (typeof document === 'undefined') {
    return;
  }

  document.body.classList.remove('ReactModal__Body--open');
  document.body.style.removeProperty('overflow');
  document.documentElement.style.removeProperty('overflow');
  document.getElementById('__next')?.removeAttribute('aria-hidden');
};
